import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsPaisClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/pais');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Pais');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/pais', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Pais');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/pais', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as Pais');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/pais/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Pais');
    }
  }

  async update(id, data) {
    try {
      const { data: response } = await this.api.put(`/pais/${id}`, data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a Pais');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.api.delete(`/pais/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Pais');
    }
  }
}
